import { CalculatorInputFieldsKey, CalculatorInputFieldsType, CalculatorInputOptions } from './CalculatorInputValue';

export class CalculatorConfig {

    private column_E15 = {
        E5: 0,
        E6: 0,
        E7: 0,
        E8: 0.0420483908856002,
        E9: 5.04042847075405,
        E10: 3.07020319473808,
        E11: 7.63286182757811,
        E12: 0.164895466290815,
        E13: 0,
        E14: 20.4630979563073,
    };

    private column_E35 = {
        E25: 1.9911838790932,
        E26: 2.59018181818182,
        E27: 6.32444444444444,
        E28: 2.85322404371585,
        E29: 3.17209387755101,
        E30: 5.3633606557377,
        E31: 3.47914487632509,
        E32: 3.07010638297872,
        E33: 2.73145759717316,
        E34: 6.25330990415335,
    };

    private column_B15 = {
        B5: 0.211181583274607,
        B6: 0.449847310312427,
        B7: 0.00634249471458774,
        B8: 0.166784120272492,
        B9: 0.925299506694856,
        B10: 0.286351891003054,
        B11: 2.51468170072821,
        B12: 0.0981912144702842,
        B13: 0.863284002818887,
        B14: 0.777777777777778,
    };

    private column_G35 = {
        G25: 2.66440643863179,
        G26: 4.54757847533632,
        G27: 20.1645454545455,
        G28: 3.6767264573991,
        G29: 5.00428360849057,
        G30: 9.53829268292682,
        G31: 5.03959329486123,
        G32: 4.53279835390946,
        G33: 4.1113911096898,
        G34: 11.0476707764079
    };

    private column_C15 = {
        C5: 0.600112755461593,
        C6: 1.17719050974865,
        C7: 0.000234907211651398,
        C8: 1.04451021846371,
        C9: 11.867298567066,
        C10: 3.83891237961005,
        C11: 12.3962978623444,
        C12: 1.31193798449612,
        C13: 8.98122151750059,
        C14: 21.4486845196148,
    };

    private column_J15 = {
        J5: 0,
        J6: 0,
        J7: 0,
        J8: 0.0420483908856002,
        J9: 0.454388066713648,
        J10: 0.174188395583744,
        J11: 0.183168898285177,
        J12: 0.164895466290815,
        J13: 0,
        J14: 0,
        J15: 1.01868921775899,
    };

    private added_cell_B = {
        B21: this.g('facility_opening_hours'),
        B22: this.g('average_number_scans'),
        B23: this.g('rate_HTM_org_performance') / 100,
    };

    private added_cell_15 = {
        E15: this.getTotalCell(this.column_E15),
        B15: this.getTotalCell(this.column_B15),
        C15: this.getTotalCell(this.column_C15),
    };

    private column_H15 = {
        H5: this.column_J15.J5 / this.column_B15.B5,
        H6: this.column_J15.J6 / this.column_B15.B6,
        H7: this.column_J15.J7 / this.column_B15.B7,
        H8: this.column_J15.J8 / this.column_B15.B8,
        H9: this.column_J15.J9 / this.column_B15.B9,
        H10: this.column_J15.J10 / this.column_B15.B10,
        H11: this.column_J15.J11 / this.column_B15.B11,
        H12: this.column_J15.J12 / this.column_B15.B12,
        H13: this.column_J15.J13 / this.column_B15.B13,
        H14: this.column_J15.J14 / this.column_B15.B14,
        H15: this.column_J15.J15 / this.added_cell_15.B15,
    };

    private column_F15 = {
        F5: this.column_E15.E5 / this.column_B15.B5,
        F6: this.column_E15.E6 / this.column_B15.B6,
        F7: this.column_E15.E7 / this.column_B15.B7,
        F8: this.column_E15.E8 / this.column_B15.B8,
        F9: this.column_E15.E9 / this.column_B15.B9,
        F10: this.column_E15.E10 / this.column_B15.B10,
        F11: this.column_E15.E11 / this.column_B15.B11,
        F12: this.column_E15.E12 / this.column_B15.B12,
        F13: this.column_E15.E13 / this.column_B15.B13,
        F14: this.column_E15.E14 / this.column_B15.B14,
        F15: this.added_cell_15.E15 / this.added_cell_15.B15,
    };

    private column_F35 = {
        F25: this.column_B15.B5 * this.column_E35.E25,
        F26: this.column_B15.B6 * this.column_E35.E26,
        F27: this.column_B15.B7 * this.column_E35.E27,
        F28: this.column_B15.B8 * this.column_E35.E28,
        F29: this.column_B15.B9 * this.column_E35.E29,
        F30: this.column_B15.B10 * this.column_E35.E30,
        F31: this.column_B15.B11 * this.column_E35.E31,
        F32: this.column_B15.B12 * this.column_E35.E32,
        F33: this.column_B15.B13 * this.column_E35.E33,
        F34: this.column_B15.B14 * this.column_E35.E34,
        F35: this.added_cell_15.E15 * this.added_cell_15.B15,
    };

    private column_J35 = {
        J25: this.column_G35.G25 * this.column_B15.B5 * (1 + this.added_cell_B.B23),
        J26: this.column_G35.G26 * this.column_B15.B6 * (1 + this.added_cell_B.B23),
        J27: this.column_G35.G27 * this.column_B15.B7 * (1 + this.added_cell_B.B23),
        J28: this.column_G35.G28 * this.column_B15.B8 * (1 + this.added_cell_B.B23),
        J29: this.column_G35.G29 * this.column_B15.B9 * (1 + this.added_cell_B.B23),
        J30: this.column_G35.G30 * this.column_B15.B10 * (1 + this.added_cell_B.B23),
        J31: this.column_G35.G31 * this.column_B15.B11 * (1 + this.added_cell_B.B23),
        J32: this.column_G35.G32 * this.column_B15.B12 * (1 + this.added_cell_B.B23),
        J33: this.column_G35.G33 * this.column_B15.B13 * (1 + this.added_cell_B.B23),
        J34: this.column_G35.G34 * this.column_B15.B14 * (1 + this.added_cell_B.B23),
    };

    private column_K35 = {
        K25: this.column_J35.J25 - this.column_F35.F25,
        K26: this.column_J35.J26 - this.column_F35.F26,
        K27: this.column_J35.J27 - this.column_F35.F27,
        K28: this.column_J35.J28 - this.column_F35.F28,
        K29: this.column_J35.J29 - this.column_F35.F29,
        K30: this.column_J35.J30 - this.column_F35.F30,
        K31: this.column_J35.J31 - this.column_F35.F31,
        K32: this.column_J35.J32 - this.column_F35.F32,
        K33: this.column_J35.J33 - this.column_F35.F33,
        K14: this.column_J35.J34 - this.column_F35.F34
    };

    private column_L35 = {
        L25: this.column_F35.F25 * 17 / 100,
        L26: this.column_F35.F26 * 17 / 100,
        L27: this.column_F35.F27 * 17 / 100,
        L28: this.column_F35.F28 * 17 / 100,
        L29: this.column_F35.F29 * 17 / 100,
        L30: this.column_F35.F30 * 17 / 100,
        L31: this.column_F35.F31 * 17 / 100,
        L32: this.column_F35.F32 * 17 / 100,
        L33: this.column_F35.F33 * 17 / 100,
        L34: this.column_F35.F34 * 17 / 100,
    };

    constructor(private d: CalculatorInputFieldsType) {
    }

    cell_I15(): number {
        const itemList = {...this.column_F15, ...this.column_B15, ...this.added_cell_15};

        const cell_I = {
            I5: this.c(itemList, 'F5', 'B5'),
            I6: this.c(itemList, 'F6', 'B6'),
            I7: this.c(itemList, 'F7', 'B7'),
            I8: this.c(itemList, 'F8', 'B8'),
            I9: this.c(itemList, 'F9', 'B9'),
            I10: this.c(itemList, 'F10', 'B10'),
            I11: this.c(itemList, 'F11', 'B11'),
            I12: this.c(itemList, 'F12', 'B12'),
            I13: this.c(itemList, 'F13', 'B13'),
            I14: this.c(itemList, 'F14', 'B14'),
        };

        return this.getTotalCell(cell_I);
    }

    cell_K15(): number {
        const itemList = {...this.column_C15, ...this.column_B15, ...this.added_cell_15};

        const cell_I = {
            I5: this.c(itemList, 'C5', 'B5'),
            I6: this.c(itemList, 'C6', 'B6'),
            I7: this.c(itemList, 'C7', 'B7'),
            I8: this.c(itemList, 'C8', 'B8'),
            I9: this.c(itemList, 'C9', 'B9'),
            I10: this.c(itemList, 'C10', 'B10'),
            I11: this.c(itemList, 'C11', 'B11'),
            I12: this.c(itemList, 'C12', 'B12'),
            I13: this.c(itemList, 'C13', 'B13'),
            I14: this.c(itemList, 'C14', 'B14'),
        };

        return this.getTotalCell(cell_I);
    }

    cell_L15(): number {
        return this.added_cell_15.C15 * 17 / 100;
    }

    cell_K35(): number {
        return this.getTotalCell(this.column_K35);
    }

    cell_L35(): number {
        return this.getTotalCell(this.column_L35);
    }

    private g(key: CalculatorInputFieldsKey): number {
        const formatValueFunction = CalculatorInputOptions[key]?.formatValueFunction;
        const value = +(this.d[key] || 0);

        return formatValueFunction?.(value) || value;
    }

    private getTotalCell(cells: Record<string, number>): number {
        return Object.keys(cells).reduce((prev, curr: any) => {
            const value = cells[curr];
            prev = prev + (isNaN(value) ? 0 : value);
            return prev;
        }, 0);
    }

    private c<T extends Record<string, number>>(itemList: T, cell_F: keyof T, cell_B: keyof T): number {
        const cell_value_F = itemList[cell_F];
        const cell_value_B = itemList[cell_B];

        return (cell_value_F < this.added_cell_B.B21
            ? cell_value_F
            : (
            cell_value_F < 24
                ? this.added_cell_B.B21
                : ((cell_value_F / 24) * this.added_cell_B.B21)
            )) * cell_value_B;
    }

}
